import { combineReducers } from 'redux';

const masterInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  willReload: false,
  tempList: [],
  query: {
    size: 20,
  },
};

const detailInitialState = {
  loadStatus: 0,
  likeStatus: 0,
  deleteStatus: 0,
  data: {
    productVos: null,
    skinCareVos: null,
    likeUserVo: null,
    mark: '',
    markId: '',
  },
}

const addInitialState = {
  saveStatus: 0,
  input: {
    content: '',
    imageVos: [],
  }
}

const historyInitialState = {
  list: null,
  loadStatus: 0,
  didLoadAll: false,
  willReload: false,
  tempList: [],
  query: {
    size: 20,
  },
}

const messageInitialState = {
  list: null,
  count: 0,
  didLoadAll: false,
  loadStatus: 0,
  readStatus: 0,
  unreadNumber: 0,
  query: {
    size: 20,
  },
}

function momentListReducer(state = masterInitialState, action) {
  switch (action.type) {
    case 'LOAD_MOMENT_LIST': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_MOMENT_LIST_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      const { data } = action;
      return {
        ...state,
        loadStatus: 2,
        didLoadAll: data.listData.length < state.query.size,
        count: data.count,
        willReload: data.willReload,
        list: state.list ? state.list.concat(data.listData) : data.listData,
        tempList: data.listData,
      };
    }

    default:
      return state;
  }
}

function momentDetailReducer(state = detailInitialState, action) {
  switch (action.type) {
    case 'LOAD_MOMENT_DETAIL': {
      return {
        ...detailInitialState,
        data: {
          ...detailInitialState.data,
        },
        loadStatus: 1,
      };
    }

    case 'LOAD_MOMENT_DETAIL_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      const { data } = action;
      return {
        ...state,
        loadStatus: 2,
        data: {...data},
      };
    }

    case 'LIKE_MOMENT': {
      return {
        ...state,
        likeStatus: 1,
      };
    }

    case 'LIKE_MOMENT_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          likeStatus: 0,
        };
      }
      return {
        ...state,
        likeStatus: 2,
      };
    }
    case 'DELETE_MOMENT': {
      return {
        ...state,
        deleteStatus: 1,
      };
    }

    case 'DELETE_MOMENT_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          deleteStatus: 0,
        };
      }
      return {
        ...state,
        deleteStatus: 2,
      };
    }

    default:
      return state;
  }
}

function addMomentReducer(state = addInitialState, action) {
  switch (action.type) {
    case 'WRITE_MOMENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'WRITE_MOMENT_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }
      return {
        ...state,
        saveStatus: 2,
      };
    }

    default:
      return state;
  }
}

function momentHistoryReducer(state = historyInitialState, action) {
  switch (action.type) {
    case 'LOAD_MOMENT_HISTORY': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_MOMENT_HISTORY_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      const { data } = action;
      return {
        ...state,
        loadStatus: 2,
        didLoadAll: data.listData.length < state.query.size,
        count: data.count,
        willReload: data.willReload,
        list: state.list ? state.list.concat(data.listData) : data.listData,
        tempList: data.listData,
      };
    }

    default:
      return state;
  }
}

function momentMessageReducer(state = messageInitialState, action) {
  switch (action.type) {
    case 'LOAD_MOMENT_MESSAGE': {
      if (!action.willReload) {
        return {
          ...state,
          loadStatus: 1,
        };
      }

      return {
        ...state,
        loadStatus: 1,
        query: {
          ...state.query,
          ...action.query,
        },
        list: null,
      };
    }

    case 'LOAD_MOMENT_MESSAGE_COMPELTION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      const { data } = action;

      const list = (data.listData || []).map(item => item.id);

      return {
        ...state,
        loadStatus: 2,
        didLoadAll: list.length < state.query.size,
        count: data.count,
        list: state.list ? state.list.concat(list) : list,
      };
    }

    case 'READ_MOMENT_MESSAGE': {
      return {
        ...state,
        readStatus: 1,
      };
    }

    case 'READ_MOMENT_MESSAGE_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          readStatus: 0,
        };
      }
      return {
        ...state,
        readStatus: 2,
      };
    }

    case 'LOAD_MOMENT_MESSAGE_UNREAD_COMPLETION': {
      return {
        ...state,
        unreadNumber: action.data,
      }
    }

    default:
      return state;
  }
}

function messageDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_MOMENT_MESSAGE_COMPELTION': {
      if (action.error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }
      const { data } = action;
      let obj = { ...state };
      (data.listData || []).forEach(element => {
        Object.assign(obj, {[element.id]: { readStatus: 0, ...element }})
      });
      return {
        ...state,
        ...obj
      };
    }

    case 'READ_MOMENT_MESSAGE': {
      const { id } = action;
      const item = {
        ...state[id],
        readStatus: 1,
      };
      return {
        ...state,
        [id]: item,
      };
    }

    case 'READ_MOMENT_MESSAGE_COMPLETION': {
      const { id } = action;
      const item = {
        ...state[id],
        isRead: 1,
        readStatus: 2,
      };
      return {
        ...state,
        [id]: item,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  master: momentListReducer,
  detail: momentDetailReducer,
  add: addMomentReducer,
  history: momentHistoryReducer,
  message: momentMessageReducer,
  messageDetails: messageDetailsReducer,
});
